<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>기술자료실</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>알아두면 좋은 꿀팁</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">동영상 자료</p>
            <p style="font-size: 20px">• 제품 분류를 선택해주세요</p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="product-list"
                    style="display: flex; align-content: center"
                >
                    <text-button
                        v-for="(model, index) in product_models"
                        :key="index"
                        :textSize="14"
                        :buttonName="model"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="setSelectedProduct(index)"
                        :clicked="index == selectedProduct"
                    ></text-button>
                </div>
            </div>
        </div>

        <div id="search" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">
                궁금한 사항을 입력하세요
            </p>
            <search-bar :size="100"></search-bar>
            <div class="row" style="gap: 32px">
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
            </div>
        </div>

        <div id="video" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p style="font-size: 28px; font-weight: bold; color: #00a7e7">
                    {{ product_models[selectedProduct] }}
                </p>
                <p style="font-size: 28px; font-weight: bold">동영상 자료</p>
            </div>
            <div id="video-list">
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
                <video-item
                    style="width: 25%"
                    :video="'https://www.youtube.com/watch?v=7jX8NbLvqfA&t=906s'"
                    :title="'로렌스 후크(hook)2 / 리빌 - 사용자 모드 선택[금호마린테크, LOWRANCE]'"
                    :date="'2022-11-17'"
                ></video-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted } from "vue";
// import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import VideoItem from "@/components/VideoItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";

export default {
    props: {
        category: {
            type: String,
            default: "GPS플로터",
        },
    },
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        VideoItem,
        CustomPagination,
    },
    setup() {
        const product_models = ref([
            "HDS PRO1",
            "HDS PRO2",
            "HDS PRO3",
            "HDS PRO4",
        ]);
        const selectedProduct = ref(0);

        const keyword_list = ref([
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "소리/진동",
            "소리/진동",
            "소리/진동",
            "소리/진동",
            "소리/진동",
        ]);
        const selectedKeyword = ref(0);

        onMounted(() => {
        });

        const setSelectedProduct = (index) => {
            selectedProduct.value = index;
        };

        const setSelectedKeyword = (index) => {
            selectedKeyword.value = index;
        };

        const currentPage = ref(1);
        const totalPages = ref(20);

        const loadPageData = (page) => {
            currentPage.value = page;
        };

        return {
            product_models,
            setSelectedProduct,
            selectedProduct,
            keyword_list,
            selectedKeyword,
            setSelectedKeyword,
            currentPage,
            totalPages,
            loadPageData,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

#search {
    padding: 32px 0px;
    gap: 24px;
}

#video {
    padding: 32px 0px;
}

#video-list {
    width: 100%;
    border: 1px solid black;
    display: flex;
    flex-wrap: wrap;
}
</style>
